export default __webpack_public_path__ + "static/media/mokhder.141aa435.png";